import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AppProvider } from "@/context/AppContext";
import { SidebarContent } from "@/components/Sidebar";
import { Topbar } from "@/components/Topbar";
import { Loader2 } from "lucide-react";

export function Layout() {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  return (
    <AppProvider>
      <div className="app-shell min-h-screen bg-background">
        <aside className="hidden lg:flex fixed inset-y-0 left-0 w-64 border-r border-border/70 bg-card z-40">
          <SidebarContent />
        </aside>
        <div className="lg:pl-64">
          <Topbar />
          <main className="px-4 sm:px-6 lg:px-8 py-6 max-w-[1500px] mx-auto">
            <Outlet />
          </main>
        </div>
      </div>
    </AppProvider>
  );
}
